[
  {
    "id": "MET-E6P-L106-001",
    "module": "Metriek",
    "difficulty": 106,
    "question": "Reken om: 1,5 dm³ = ... liter",
    "options": ["1,5 liter", "15 liter", "150 liter", "0,15 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_kubiek",
    "familyId": "MET-DM3-L",
    "explanation": "1 dm³ is precies evenveel als 1 liter. Dus 1,5 dm³ = 1,5 liter.",
    "distractorExplanations": {
      "1": "Je hebt met 10 vermenigvuldigd.",
      "2": "Je hebt met 100 vermenigvuldigd.",
      "3": "Je hebt door 10 gedeeld."
    }
  },
  {
    "id": "MET-E6P-L106-002",
    "module": "Metriek",
    "difficulty": 106,
    "question": "Een kamer is 4 m lang, 3 m breed en 2 m hoog. Wat is de inhoud?",
    "options": ["24 m³", "18 m³", "9 m³", "24 m²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_berekenen",
    "familyId": "MET-INHOUD-KAMER",
    "explanation": "Inhoud = lengte × breedte × hoogte. 4 × 3 × 2 = 24 kubieke meter.",
    "distractorExplanations": {
      "1": "Je hebt de omtrek berekend.",
      "2": "Je hebt opgeteld.",
      "3": "De eenheid is fout (m² is oppervlakte)."
    }
  },
  {
    "id": "MET-E6P-L106-003",
    "module": "Metriek",
    "difficulty": 106,
    "question": "Hoeveel gram is 2,5 ton?",
    "options": ["2.500.000 gram", "2.500 gram", "25.000 gram", "250.000 gram"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_ton",
    "familyId": "MET-TON-G",
    "explanation": "1 ton = 1.000 kg = 1.000.000 gram. 2,5 ton is dus 2.500.000 gram.",
    "distractorExplanations": {
      "1": "Dat is 2,5 kg.",
      "2": "Dat is 25 kg.",
      "3": "Dat is 250 kg."
    }
  },
  {
    "id": "MET-E6P-L106-004",
    "module": "Metriek",
    "difficulty": 106,
    "question": "De oppervlakte van een tuin is 600 m². De lengte is 30 m. Wat is de breedte?",
    "options": ["20 m", "200 m", "30 m", "10 m"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_terug",
    "familyId": "MET-OPP-TERUG",
    "explanation": "Oppervlakte = lengte × breedte. 600 = 30 × ?. 600 : 30 = 20 meter.",
    "distractorExplanations": {
      "1": "30 × 200 = 6000.",
      "2": "30 × 30 = 900.",
      "3": "30 × 10 = 300."
    }
  },
  {
    "id": "MET-E6P-L106-005",
    "module": "Metriek",
    "difficulty": 106,
    "question": "Reken om: 500 cl = ... liter",
    "options": ["5 liter", "50 liter", "0,5 liter", "5000 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_cl",
    "familyId": "MET-CL-L",
    "explanation": "100 cl = 1 liter. 500 cl is dus 5 liter.",
    "distractorExplanations": {
      "1": "Dat is 5000 cl.",
      "2": "Dat is 50 cl.",
      "3": "Dat is 5.000.000 cl."
    }
  },
  {
    "id": "MET-E6P-L106-006",
    "module": "Metriek",
    "difficulty": 106,
    "question": "Een doos is 50 cm lang, 30 cm breed en 20 cm hoog. Wat is de inhoud in liters?",
    "options": ["30 liter", "3 liter", "300 liter", "0,3 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_berekenen",
    "familyId": "MET-INHOUD-DOOS",
    "explanation": "50 × 30 × 20 = 30.000 cm³. 1 liter = 1.000 cm³. 30.000 : 1.000 = 30 liter.",
    "distractorExplanations": {
      "1": "Je deelde nog een keer extra door 10.",
      "2": "Je vergat te delen door 1.000.",
      "3": "Je deelde door 100.000."
    }
  },
  {
    "id": "MET-E6P-L106-007",
    "module": "Metriek",
    "difficulty": 106,
    "question": "Hoeveel kilogram is 0,5 ton?",
    "options": ["500 kg", "50 kg", "5.000 kg", "5 kg"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_ton",
    "familyId": "MET-HALVE-TON",
    "explanation": "1 ton = 1.000 kg. 0,5 ton = 500 kg.",
    "distractorExplanations": {
      "1": "Je deed ×100 in plaats van ×1.000.",
      "2": "Je deed ×10.000.",
      "3": "Je deed ×10."
    }
  },
  {
    "id": "MET-E6P-L106-008",
    "module": "Metriek",
    "difficulty": 106,
    "question": "Een zwembad is 25 m lang en 10 m breed. De oppervlakte is 250 m². Hoeveel is dat in cm²?",
    "options": ["2.500.000 cm²", "250.000 cm²", "25.000 cm²", "25.000.000 cm²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_terug",
    "familyId": "MET-OPP-M2-CM2",
    "explanation": "1 m² = 10.000 cm². 250 × 10.000 = 2.500.000 cm².",
    "distractorExplanations": {
      "1": "Je deed ×1.000 in plaats van ×10.000.",
      "2": "Je deed ×100.",
      "3": "Je deed ×100.000."
    }
  },
  {
    "id": "MET-E6P-L106-009",
    "module": "Metriek",
    "difficulty": 106,
    "question": "Reken om: 2.500 ml = ... liter",
    "options": ["2,5 liter", "25 liter", "0,25 liter", "250 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_cl",
    "familyId": "MET-ML-L",
    "explanation": "1.000 ml = 1 liter. 2.500 : 1.000 = 2,5 liter.",
    "distractorExplanations": {
      "1": "Je deelde door 100.",
      "2": "Je deelde door 10.000.",
      "3": "Je deed ×100."
    }
  },
  {
    "id": "MET-E6P-L106-010",
    "module": "Metriek",
    "difficulty": 106,
    "question": "Een balk is 2 m lang, 0,5 m breed en 0,3 m hoog. Wat is de inhoud?",
    "options": ["0,3 m³", "3 m³", "0,03 m³", "30 m³"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_berekenen",
    "familyId": "MET-INHOUD-BALK",
    "explanation": "Inhoud = 2 × 0,5 × 0,3 = 0,3 m³.",
    "distractorExplanations": {
      "1": "Je vergat de komma's.",
      "2": "Je deed 2 × 0,5 × 0,03.",
      "3": "Je deed 2 × 5 × 3."
    }
  },
  {
    "id": "MET-E6P-L106-011",
    "module": "Metriek",
    "difficulty": 106,
    "question": "Hoeveel kg is 3.750 gram?",
    "options": ["3,75 kg", "37,5 kg", "0,375 kg", "375 kg"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_ton",
    "familyId": "MET-G-KG-3750",
    "explanation": "3.750 : 1.000 = 3,75 kg.",
    "distractorExplanations": {
      "1": "Je deelde door 100.",
      "2": "Je deelde door 10.000.",
      "3": "Je deed ×100."
    }
  },
  {
    "id": "MET-E6P-L106-012",
    "module": "Metriek",
    "difficulty": 106,
    "question": "Een rechthoek heeft een oppervlakte van 84 m². De breedte is 7 m. Wat is de lengte?",
    "options": ["12 m", "11 m", "14 m", "77 m"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_terug",
    "familyId": "MET-OPP-TERUG-2",
    "explanation": "Oppervlakte = lengte × breedte. 84 = ? × 7. 84 : 7 = 12 m.",
    "distractorExplanations": {
      "1": "7 × 11 = 77, niet 84.",
      "2": "7 × 14 = 98, niet 84.",
      "3": "Je trok 7 af in plaats van te delen."
    }
  },
  {
    "id": "MET-E6P-L106-013",
    "module": "Metriek",
    "difficulty": 106,
    "question": "Reken om: 3 dm³ = ... ml",
    "options": ["3.000 ml", "300 ml", "30 ml", "30.000 ml"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_kubiek",
    "familyId": "MET-DM3-ML",
    "explanation": "1 dm³ = 1 liter = 1.000 ml. 3 dm³ = 3.000 ml.",
    "distractorExplanations": {
      "1": "Je deed ×100.",
      "2": "Je deed ×10.",
      "3": "Je deed ×10.000."
    }
  },
  {
    "id": "MET-E6P-L106-014",
    "module": "Metriek",
    "difficulty": 106,
    "question": "Een vrachtwagen weegt 3,2 ton. Hoeveel kilogram is dat?",
    "options": ["3.200 kg", "320 kg", "32.000 kg", "32 kg"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_ton",
    "familyId": "MET-TON-KG",
    "explanation": "1 ton = 1.000 kg. 3,2 × 1.000 = 3.200 kg.",
    "distractorExplanations": {
      "1": "Je deed ×100.",
      "2": "Je deed ×10.000.",
      "3": "Je deed ×10."
    }
  },
  {
    "id": "MET-E6P-L106-015",
    "module": "Metriek",
    "difficulty": 106,
    "question": "Reken om: 750 cl = ... liter",
    "options": ["7,5 liter", "75 liter", "0,75 liter", "750 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_cl",
    "familyId": "MET-CL-L-2",
    "explanation": "100 cl = 1 liter. 750 : 100 = 7,5 liter.",
    "distractorExplanations": {
      "1": "Je deelde door 10.",
      "2": "Je deelde door 1.000.",
      "3": "Je deelde niet."
    }
  }
]